import {format, parseISO} from "date-fns";

import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {IsItDownServiceStatusPill, PublicProfilesComponent} from "@/lib/types/isitdown.ts";
import {MarketingTable} from "@/marketingPages/components/marketingtable/MarketingTable.tsx";

import styles from "./ComponentStatus.module.scss";

interface ComponentStatusProps {
  components: PublicProfilesComponent[];
}

export const ComponentStatus = ({components}: ComponentStatusProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Component Status</div>
      <MarketingTable
        variant="white"
        overlay={
          <a href={`${URL_ORIGINAL_WEBSITE}/accounts/register`} className={styles.overlay}>
            Sign Up to View Full Component History →
          </a>
        }
        rows={components}
        specs={[
          {
            fieldName: "name",
            fieldTitle: "COMPONENT NAME",
            meta: {columnClassName: styles.componentNameColumn},
          },
          {
            fieldName: "status",
            fieldTitle: "CURRENT STATUS",
            accessor: ({status}) => (
              <StatusPill type="checks" variant="textAndIcon" status={IsItDownServiceStatusPill[status]} />
            ),
            meta: {columnClassName: "text-nowrap"},
          },
          {
            fieldName: "status_started_at",
            fieldTitle: "STARTED",
            accessor: ({status_started_at}) => format(parseISO(status_started_at), "PP pp"),
            meta: {columnClassName: "text-nowrap"},
          },
          {
            fieldName: "status_updated_at",
            fieldTitle: "LAST UPDATE",
            accessor: ({status_updated_at}) => format(parseISO(status_updated_at), "PP pp"),
            meta: {columnClassName: "text-nowrap"},
          },
          {
            fieldName: "details",
            fieldTitle: "DETAILS",
            accessor: () => (
              <a href={`${URL_ORIGINAL_WEBSITE}/accounts/register`} className="pulse-color-blue-500">
                View details
              </a>
            ),
            meta: {columnClassName: "text-nowrap"},
          },
        ]}
      />
    </div>
  );
};
